"use client";

import { useRef } from "react";
import { Link } from "react-router-dom";

export default function AppDownload() {
  const containerRef = useRef(null);

  return (
    <div
      ref={containerRef}
      className="w-full flex items-center justify-center overflow-hidden relative font-fraunces"
    >
      {/* Logo - Hidden on small screens, visible on medium screens and up */}

      <div className="pl-0 pt-12 pb-4 w-full h-full max-w-xl xl:max-w-3xl 2xl:max-w-4xl flex items-center justify-center px-4">
        <div className="relative w-full max-h-[90vh]">
          {/* Container for image with fluid responsive sizing */}
          <div className="flex justify-center items-center">
            <div className="relative w-[95%] sm:w-[90%] md:w-[95%] lg:w-[90%] xl:w-[95%] 2xl:w-[100%]">
              <img
                src="/images/ctabg.png"
                alt="App on iPhone and Laptop"
                className="w-full h-auto rounded-3xl max-h-[85vh] object-contain"
              />

              {/* Text Overlay - Using more fluid positioning with clamp() via inline style */}
              <div
                className="absolute w-full text-center"
                style={{
                  top: "clamp(0.5rem, 2vh, 2rem)",
                  paddingLeft: "clamp(1rem, 2vw, 2.5rem)",
                }}
              >
                <div className="px-2 sm:px-3 md:px-4 xl:px-5 2xl:pt-5">
                  <h2 className="font-bold text-gray-800 text-[clamp(1.5rem,2.5vw,2.5rem)] xl:text-[clamp(1rem,3vw,3rem)] 2xl:text-7xl leading-tight">
                    Real{" "}
                    <span className="text-[#7b189f] font-fraunces">People</span>
                    . Real
                  </h2>
                  <h2 className="font-bold text-gray-800 text-[clamp(1.5rem,2.5vw,2.5rem)] xl:text-[clamp(1rem,3vw,3rem)] 2xl:text-7xl leading-tight">
                    <span className="text-[#7b189f] font-fraunces ">
                      Places
                    </span>
                    . Real-
                    <span className="text-[#7b189f] font-fraunces">Time</span>
                  </h2>
                  <p className="mt-1 text-[calc(0.5rem+2px)] sm:text-[calc(0.5rem+2px)] md:text-[calc(0.5rem+2px)] lg:text-xs xl:sm 2xl:text-xl text-gray-700">
                    The streets never sleep - now they speak.
                  </p>
                </div>
              </div>

              {/* Buttons Overlay - Improved positioning and styling */}
              <div
                className="absolute w-full flex flex-col items-center"
                style={{
                  bottom: "clamp(0.5rem, 2%, 4rem)",
                  left: "0",
                }}
              >
                {/* App Store Buttons with improved spacing and hover effects */}
                <div className="flex justify-center gap-[clamp(0.75rem,2vw,2rem)] mb-[clamp(0.15rem,1.5vw,1rem)]">
                  <a
                    href="https://apps.apple.com/us/app/gallyo/id6745209299"
                    className="transition-all duration-300 hover:scale-105 focus:scale-105 focus:outline-none focus:ring-2 focus:ring-[#7b189f] focus:ring-offset-2 rounded-lg"
                    aria-label="Download on the App Store"
                  >
                    <img
                      src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/download-on-the-app-store-apple-logo-svgrepo-com%201%20%281%29-4cFGCEAypGXuZ88bGbfMtipW9lryxh.png"
                      alt="Download on the App Store"
                      className="h-auto w-[clamp(4.5rem,13vw,9rem)] xl:w-[clamp(5.5rem,15vw,11rem)] drop-shadow-md"
                    />
                  </a>
                  <a
                    href="https://play.google.com/store/apps/details?id=com.leantechop.pingdesi&pcampaignid=web_share"
                    className="transition-all duration-300 hover:scale-105 focus:scale-105 focus:outline-none focus:ring-2 focus:ring-[#7b189f] focus:ring-offset-2 rounded-lg"
                    aria-label="Get it on Google Play"
                  >
                    <img
                      src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/Google_Play_Store_badge_EN%201%20%281%29-cqx9EmT35nHTTDUoo4kRMJdNtmhr96.png"
                      alt="Get it on Google Play"
                      className="h-auto w-[clamp(4.5rem,13vw,9rem)] xl:w-[clamp(5.5rem,15vw,11rem)] drop-shadow-md"
                    />
                  </a>
                </div>

                {/* Web Button with enhanced styling */}
                <Link
                  to="/home"
                  className="inline-flex items-center font-afacad justify-center rounded-md bg-[#323232] px-[clamp(1rem,3vw,1.5rem)] py-[clamp(0.4rem,1vh,0.6rem)] text-[clamp(0.75rem,1vw,1.5rem)] font-medium text-white shadow-md transition-all duration-300 hover:scale-105 hover:bg-[#8a1eb3] hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-[#7b189f] focus:ring-offset-2 active:scale-95"
                  aria-label="Join us on Web"
                >
                  Try Web
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
